export const whiteListRequest = [
  "/api/v1/user/login/sms",
  "/api/v1/user/login",
  "/api/v1/user/sms/send_code",
  "/api/v1/user/sms/verify_code",
  "/api/v1/user/register",
  "/api/v1/user/reset_password",
  "/api/v1/user/exist_phone_number",
  "/api/v1/user/users/qunfeng/authorize",
  "/api/v1/user/public/config?key=app_config",
  "/api/v1/user/verify",
  "/api/v1/video/screen/video",
  "/api/v1/video/screen/hot_work",
  "/api/v1/video/screen/interaction",
  "/api/v1/video/screen/hot_word",
  "/api/v1/video/screen/hot_word_statistics",
  "/api/v1/video/screen/total",
  "/api/v1/video/screen/info",
  "/api/v1/video/screen/business",
  "/api/v1/video/screen/leads",
  "/api/v1/video/screen/release",
  "/api/v1/video/screen/share_sign",
  // "/api/v1/video/auth/smart_strategy/team/business",
];
